export class DistributorListFilter {

  constructor() { }

  name: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/models/distributor-list-filter.ts